import { get } from 'lodash';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import {
  getReactSelectValue,
  ReactSelectInput,
} from '@hivebrite/design-system/Inputs';

import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';

export enum OPTIONS {
  ONE = 1,
  TWO = 2,
}

const NumberButtons = ({
  defaultValue,
  item,
  onChange,
  settingKey = 'numberButtons',
  title = s__('Builder|Number of button(s)'),
}) => {
  const [value, setValue] = useState(defaultValue);

  const options = [
    { label: s__('Builder|1'), value: OPTIONS.ONE },
    { label: s__('Builder|2'), value: OPTIONS.TWO },
  ];

  useEffect(() => {
    setValue(get(item.attributes, settingKey));
  }, [item.attributes, settingKey]);

  const handleChange = (e) => {
    setValue(e.value);

    onChange(e.value);
  };

  const formattedValue = getReactSelectValue(options, value);

  return (
    <Wrapper>
      <InputTitle id="settinsgsNumberButtons" label={title} position="left" />
      <ReactSelectInput
        id="settinsgsNumberButtons"
        name="settinsgsNumberButtons"
        onChange={handleChange}
        options={options}
        placeholder={value}
        value={formattedValue}
        variant="small"
        width={100}
      />
    </Wrapper>
  );
};

export default NumberButtons;

const Wrapper = styled(Box).attrs(() => ({
  alignItems: 'center',
  justifyContent: 'space-between',
  mb: 4,
}))``;
